import { quickpayConstants } from "./quick-pay-constants";

const initialState = [];
export function balanceDetails(state = initialState, action) {
  switch (action.type) {
    case quickpayConstants.QUICK_PAY_SUCCESS:
      return { ...state, accountInfo: action.accountInfo};
   default:
      return state;
  }
}
